import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../services/api';
import '../../styles/global.css';

interface ProductionHistoryItem {
  id: number;
  production_item_id: number;
  user_id: number;
  shift: 'zmiana_1' | 'zmiana_2';
  quantity: string;
  produced_at: string;
  created_at: string;
  user: {
    id: number;
    name: string;
    email: string;
  };
  productionItem: {
    id: number;
    material: string | null;
    nazwa_oryg: string | null;
  };
}

const ProductionHistory: React.FC = () => {
  const { itemId } = useParams<{ itemId: string }>();
  const [history, setHistory] = useState<ProductionHistoryItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (itemId) {
      fetchHistory();
    }
  }, [itemId]);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/production-items/${itemId}/history`);
      setHistory(response.data);
    } catch (error) {
      console.error('Error fetching history:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('pl-PL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getShiftLabel = (shift: string) => {
    return shift === 'zmiana_1' ? '1 Zmiana' : '2 Zmiana';
  };

  if (loading) {
    return (
      <div className="loading-spinner">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1>📊 Historia Produkcji</h1>
        <button onClick={() => window.history.back()} className="btn btn-outline">
          ← Powrót
        </button>
      </div>

      {history.length === 0 ? (
        <div className="empty-state">
          <p>Brak historii produkcji dla tej pozycji.</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="table-responsive">
            <thead>
              <tr>
                <th>Data i Czas</th>
                <th>Zmiana</th>
                <th>Ilość</th>
                <th>Użytkownik</th>
                <th>Produkt</th>
              </tr>
            </thead>
            <tbody>
              {history.map((item) => (
                <tr key={item.id}>
                  <td>{formatDate(item.produced_at)}</td>
                  <td>
                    <span
                      className="status-badge"
                      style={{
                        backgroundColor: item.shift === 'zmiana_1' ? '#e3f2fd' : '#fff3e0',
                        color: item.shift === 'zmiana_1' ? '#1976d2' : '#e65100',
                      }}
                    >
                      {getShiftLabel(item.shift)}
                    </span>
                  </td>
                  <td style={{ fontWeight: 'bold', fontSize: '16px', color: '#10b981' }}>
                    {item.quantity}
                  </td>
                  <td>{item.user.name}</td>
                  <td>{item.productionItem?.material || item.productionItem?.nazwa_oryg || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ProductionHistory;

